/**
 * Utility function to facilitate exhaustive switches and conditional statements. Example Stack Overflow:
 * https://stackoverflow.com/questions/39419170/how-do-i-check-that-a-switch-block-is-exhaustive-in-typescript
 *
 * @param exhaustedType A value (typically a union or Enum) whose type has been exhausted through some kind of switch statement or series of if-else statements.
 * @param fallbackDefaultValue A fallback value that will be use just in case the type system failed to properly exhaust all possibilities (typically because of JS code or `any` typings).
 */
export const neverDefault = <V>(exhaustedType: never, fallbackDefaultValue: V) =>
  fallbackDefaultValue;

export const neverVoid = <V>(exhaustedType: never): void => {};
